import { POLL_TYPE, VERTICAL_EMBED_TYPE, VIDEO_TYPE, LINK_PREVIEW_TYPE, TABLE_TYPE } from 'wix-rich-content-common';

const getTableParams = (componentData) => {
  var _a, _b;
  return {
    rows: (_a = componentData == null ? void 0 : componentData.config) == null ? void 0 : _a.rowsHeight.length,
    columns: (_b = componentData == null ? void 0 : componentData.config) == null ? void 0 : _b.colsWidth.length
  };
};
const getEmbedService = (buttonName) => buttonName.substr(0, buttonName.indexOf("_InsertButton"));
const getLinkPreviewParams = (componentData, buttonName) => {
  var _a, _b;
  return {
    link: ((_b = (_a = componentData == null ? void 0 : componentData.config) == null ? void 0 : _a.link) == null ? void 0 : _b.url) || "",
    service: getEmbedService(buttonName)
  };
};
const getVideoParams = (componentData, buttonName) => {
  var _a;
  return {
    link: ((_a = componentData == null ? void 0 : componentData.src) == null ? void 0 : _a.pathname) || (componentData == null ? void 0 : componentData.src) || "",
    service: getEmbedService(buttonName)
  };
};
const getVerticalEmbedParams = (componentData) => {
  var _a;
  return {
    type: componentData == null ? void 0 : componentData.type,
    id: (_a = componentData == null ? void 0 : componentData.selectedProduct) == null ? void 0 : _a.id
  };
};
const getPollParams = (componentData) => {
  var _a, _b;
  return {
    type: (_b = (_a = componentData == null ? void 0 : componentData.layout) == null ? void 0 : _a.poll) == null ? void 0 : _b.type
  };
};
const getPluginParams = (data, blockType) => {
  const { componentData, buttonName } = data;
  switch (blockType) {
    case TABLE_TYPE:
      return getTableParams(componentData);
    case LINK_PREVIEW_TYPE:
      return getLinkPreviewParams(componentData, buttonName);
    case VIDEO_TYPE:
      return getVideoParams(componentData, buttonName);
    case VERTICAL_EMBED_TYPE:
      return getVerticalEmbedParams(componentData);
    case POLL_TYPE:
      return getPollParams(componentData);
    default:
      return void 0;
  }
};

export { getPluginParams };
//# sourceMappingURL=getPluginParams.js.map
